import script from "./TopSettingsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopSettingsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopSettingsPanel.vue?vue&type=style&index=0&id=360f0454&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360f0454"]])

export default __exports__